module.exports = __webpack_public_path__ + "img/aa6.b2596e60.png";